import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

const FolderReviewers = ({reviewers}) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className={styles.sectionTitle}>{t('Assigned reviewers')}</div>
      <div className={styles.reviersList}>
        {
          reviewers.length
            ? reviewers.map(reviewer => {
                return (
                  <div key={reviewer.id} className={styles.badge}>
                    <div className={styles.badgeDot} style={{backgroundColor: '#13D246'}} />
                    <div className={styles.badgeName}>{ reviewer.name } { reviewer.surname }</div>
                  </div>
                )
              })
            : <div className={styles.badge}>
                <div className={styles.badgeDot} style={{backgroundColor: '#D21313'}} />
                <div className={styles.badgeName}>{ t('None') }</div>
              </div>
        }
      </div>
    </div>
  )
}

export default FolderReviewers

